import type { GameMeta } from '@gmp/game-sdk';

/** Catalog data only (no rules or content), so menus can show the game without loading it. */
export const snapScrambleMeta = {
  id: 'snapscramble',
  name: 'SnapScramble',
  tagline: 'Same ridiculous prompt. Your real world. Fastest wit wins.',
  description: 'Everyone gets the same absurd photo challenge. Find it, stage it or caption it with whatever is around you, then vote for the best.',
  minPlayers: 3,
  maxPlayers: 20,
  estimatedMinutes: [10, 20],
  usesMedia: true,
  modes: [
    { id: 'classic', name: 'Classic', description: 'Timed rounds together: Photo Dash, Stage It, Reverse Caption and Restriction.' },
    { id: 'marathon', name: 'Marathon', description: 'No timers. Each round moves on once everyone has submitted and voted. Play it over a week.' },
    { id: 'checklist', name: 'Checklist', description: 'The whole list at once, shot in any order. Voting opens once everyone has done enough.' },
  ],
  theme: { primary: '#00e5ff', secondary: '#ff8a00', background: '#0b1630', ink: '#eafcff' },
  readiness: 'playable',
  genre: 'Photo scavenger hunt',
  controls: 'camera',
  category: 'party',
  instructions: [
    { icon: 'Sparkles', title: 'Same prompt, everywhere', body: 'Everyone sees the same challenge at the same moment, wherever they are.' },
    { icon: 'Camera', title: 'Snap it', body: 'Find, stage or caption something with what is around you before the timer ends.' },
    { icon: 'Images', title: 'Anonymous gallery', body: 'Photos appear with no names attached. Nobody knows whose is whose.' },
    { icon: 'Vote', title: 'Vote for the best', body: '100 for submitting, 200 per vote, 75 per second-choice vote, 150 for the round win.' },
  ],
} satisfies GameMeta;
